import { render, staticRenderFns } from "./CampaignDataAnalysis.vue?vue&type=template&id=20f864ce"
import script from "./CampaignDataAnalysis.vue?vue&type=script&lang=js"
export * from "./CampaignDataAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports